export default "__VITE_ASSET__BY4F8o0R__"